<template>

  <popup-modal ref="popup">
    <v-card>

      <v-card-title class="mt-0 pa-0">
        <v-toolbar color="primary" dark>
          {{title}}
        </v-toolbar>
      </v-card-title>


      <v-card-text>
        <div v-html="memo"></div>
      </v-card-text>

      <!--                Actions-->
      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn @click="Positive" color="primary">{{positiveTitle}}</v-btn>
      </v-card-actions>

    </v-card>
  </popup-modal>

</template>


<script>
import axios from "axios";
import PopupModal from "@/components/PopupModal";

export default {
  name: 'DialogInfoWeb',
  components: { PopupModal },
  data: () => ({
    title: "Информация",
    positiveTitle:"",
    memo: "<h1>Загрузка...</h1>",
    positive: undefined,
    negative: undefined,

    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods:{
    show(opts = {}) {
      this.positiveTitle = opts.positiveTitle
      this.title = opts.title
      //console.log(opts.src)
      axios.get(opts.src).then((response) => {
        //console.log(response.data)
        this.memo = response.data
      }).catch((error)=> {console.log('error: ',error)})

      // Once we set our config, we tell the popup modal to open
      const mobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))

      this.$refs.popup.open(mobile, true,'auto')

      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },


    Positive(){
      this.$refs.popup.close()
      this.resolvePromise({answer: 'positive', picker: this.picker})
    },
    Negative(){
      this.$refs.popup.close()
      this.resolvePromise({answer: 'negative'})
    },
  },
};
</script>
